import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createContact, contactsQueryKeys } from '@api/contacts';
import type { ApiContact } from '@api/contacts';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from '../useTranslation';

interface UseCreateContactOptions {
  onSuccess?: (contact: ApiContact) => void;
}

// Create-contact mutation (GRAIN-1915). Mirrors useCreateLocation;
// invalidation + toast live here so callers only handle UI (closing the modal).
export function useCreateContact(options?: UseCreateContactOptions) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: createContact,
    onSuccess: (contact) => {
      queryClient.invalidateQueries({ queryKey: contactsQueryKeys.lists() });
      toast({ description: t('create_modal.success') });
      options?.onSuccess?.(contact);
    },
  });
}
